import React, { useState, useEffect } from "react";
import Input from "@mui/material/Input";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";

const SubscriptionSearchBar = ({
  subscriptionsList,
  setFilteredSubscriptions,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const filterSubscriptions = () => {
      const normalizedSearchTerm = searchTerm.toLowerCase();

      const filtered = subscriptionsList.filter((item) => {
        const { parkingCode, subscriptionNumber, placeAddress } = item;

        return (
          subscriptionNumber?.toLowerCase().includes(normalizedSearchTerm) ||
          parkingCode?.toLowerCase().includes(normalizedSearchTerm) ||
          placeAddress?.toLowerCase().includes(normalizedSearchTerm)
        );
      });

      setFilteredSubscriptions(filtered);
    };

    filterSubscriptions();
  }, [searchTerm, setFilteredSubscriptions, subscriptionsList]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const clearSearch = () => {
    setSearchTerm("");
  };

  return (
    <Input
      placeholder="Search by Subscription #, Parking Code, Address"
      value={searchTerm}
      onChange={handleSearch}
      fullWidth
      endAdornment={
        <InputAdornment position="end">
          {searchTerm && (
            <IconButton color="secondary" onClick={clearSearch} size="medium">
              <ClearIcon />
            </IconButton>
          )}
          <IconButton color="secondary" size="medium">
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );
};

export default SubscriptionSearchBar;
